import { render, staticRenderFns } from "./copopsomapping.vue?vue&type=template&id=6b8b40ba"
import script from "./copopsomapping.vue?vue&type=script&lang=js"
export * from "./copopsomapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports